// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

::ng-deep .page-heading .col-lg-10 {
  /*float: left;
  width: 75%;*/
}
::ng-deep .page-heading .col-lg-10.header-full h2 {
  padding-right: 0px;
}
@media only screen and (min-width: 769px) {
  ::ng-deep .page-heading .col-lg-10.header-full {
    width: 60%;
  }
}
@media only screen and (max-width: 768px) {
  ::ng-deep .page-heading .col-lg-10.header-full {
    width: 100%;
  }
  ::ng-deep .page-heading .col-lg-10.header-full h2 {
    padding-right: 50px;
  }
}
::ng-deep .page-heading .header-back {
  width: 25%;
  float: left;
  text-align: right;
  padding-right: 0;
  padding-top: 30px;
}
@media only screen and (max-width: 768px) {
  ::ng-deep .page-heading .header-back {
    padding-top: 50px;
  }
}
::ng-deep .page-heading .header-back.full-screen-option {
  width: 100%;
  padding-top: 10px;
  padding-right: 15px;
}
@media only screen and (min-width: 769px) {
  ::ng-deep .page-heading .header-back.full-screen-option {
    width: 40%;
    padding-top: 30px;
  }
}
@media only screen and (max-height: 736px) and (orientation: landscape) {
  ::ng-deep .page-heading .header-back.full-screen-option {
    padding-top: 0px;
    float: right;
    width: 50%;
    margin-top: -20px;
  }
}

/*===== learner map css ============*/
/* Style-for leaner-map */
::ng-deep .course-index .ibox {
  position: relative;
}
::ng-deep .course-index .ibox:hover .product-box {
  border: none;
  box-shadow: 3px 3px 7px 0px #a8a8a8;
}
::ng-deep .course-index .ibox:hover .icon-btn {
  color: #48ac51;
}
::ng-deep .course-index .ibox input[type=checkbox] {
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
  z-index: 1;
}
::ng-deep .course-index .ibox input[type=checkbox]:checked ~ div.product-box {
  border: none;
  box-shadow: 3px 3px 7px 0px #a8a8a8;
}
::ng-deep .course-index .ibox input[type=checkbox]:checked ~ div.product-box a.icon-btn {
  color: #48ac51;
}
::ng-deep .course-index .ibox input[type=checkbox]:checked ~ div.popover {
  display: block;
  top: 130px;
  left: -100px;
  margin-top: 15px;
}
@media screen and (max-width: 679px) {
  ::ng-deep .course-index .ibox input[type=checkbox]:checked ~ div.popover {
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    max-width: 350px;
    min-width: auto;
    width: 100%;
  }
}
::ng-deep .course-index .ibox input[type=checkbox]:checked ~ div.popover > .arrow {
  left: 50%;
  margin-left: -11px;
  border-top-width: 0;
  border-bottom-color: #999999;
  border-bottom-color: rgba(0, 0, 0, 0.25);
  top: -11px;
}
::ng-deep .course-index .ibox input[type=checkbox]:checked ~ div.popover > .arrow:after {
  content: " ";
  top: 1px;
  margin-left: -10px;
  border-top-width: 0;
  border-bottom-color: #f7f7f7;
}

@media only screen and (max-width: 1400px) {
  ::ng-deep .cta-wrapper .list-group-item span {
    max-width: 53%;
    word-wrap: break-word;
  }
}

::ng-deep .img-shadow {
  box-shadow: inset 0 0 8px rgba(0, 0, 0, 0.6);
  -moz-box-shadow: inset 0 0 8px rgba(0, 0, 0, 0.6);
  -webkit-box-shadow: inset 0 0 8px rgba(0, 0, 0, 0.6);
  background-size: 100% !important;
  background-position: 0;
}
::ng-deep .img-shadow .build-form {
  margin-top: 30px !important;
}

/* box-detail*/
::ng-deep .dash-practitioner-wrapper ::ng-deep .ibox.product-detail .ibox-content .image-imitation, .wrapper-learner-map ::ng-deep .ibox.product-detail .ibox-content .image-imitation {
  min-height: 642px !important;
}
@media only screen and (max-width: 1400px) {
  ::ng-deep .dash-practitioner-wrapper ::ng-deep .ibox.product-detail .ibox-content .image-imitation, .wrapper-learner-map ::ng-deep .ibox.product-detail .ibox-content .image-imitation {
    min-height: 350px !important;
  }
}
::ng-deep .dash-practitioner-wrapper ::ng-deep .ibox.product-detail .ibox-content .image-imitation .build-form, .wrapper-learner-map ::ng-deep .ibox.product-detail .ibox-content .image-imitation .build-form {
  max-width: 300px;
  margin: 0 auto;
  float: none;
}
::ng-deep .dash-practitioner-wrapper ::ng-deep .ibox.product-detail .ibox-content .image-imitation .build-form input[type=email], .wrapper-learner-map ::ng-deep .ibox.product-detail .ibox-content .image-imitation .build-form input[type=email] {
  width: 90%;
}
::ng-deep .dash-practitioner-wrapper ::ng-deep .ibox.product-detail .ibox-content .image-imitation .build-form .fa, .wrapper-learner-map ::ng-deep .ibox.product-detail .ibox-content .image-imitation .build-form .fa {
  cursor: pointer;
}
::ng-deep .dash-practitioner-wrapper ::ng-deep .ibox.product-detail .ibox-content .image-imitation .build-form fieldset, .wrapper-learner-map ::ng-deep .ibox.product-detail .ibox-content .image-imitation .build-form fieldset {
  margin-bottom: 5px;
}

::ng-deep span.spacer {
  display: block;
  clear: both;
  margin-bottom: 8px;
}

::ng-deep .media-container {
  position: relative;
  padding-top: 0%;
}
@media only screen and (max-width: 991px) {
  ::ng-deep .media-container {
    padding-top: 0%;
    margin: 15px 0px;
  }
}
::ng-deep .media-container .image-imitation {
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  min-height: inherit !important;
  overflow: auto;
}
::ng-deep .media-container .image-imitation iframe {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}

::ng-deep .work-well-slide h3 {
  font-size: 22px;
}
::ng-deep .work-well-slide .title-sm {
  margin-bottom: 50px !important;
}
@media (max-width: 767px) {
  ::ng-deep .work-well-slide .title-sm {
    margin-bottom: 25px !important;
  }
}
::ng-deep .work-well-slide .disabled {
  height: 50px;
  vertical-align: middle;
  margin-top: 35px;
  font-size: 28px;
}
@media (max-width: 767px) {
  ::ng-deep .work-well-slide .disabled {
    margin: 0px;
  }
}

::ng-deep .media-content {
  position: static;
}
::ng-deep .media-content .confirmation-box {
  padding: 5px;
  border-top: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
  width: 250px;
  clear: both;
  margin-top: 20px;
}
::ng-deep .media-content .checkbox-circle {
  font-size: 13px;
  font-style: italic;
  float: right;
  margin-right: -23px;
  margin-top: 7px;
}
::ng-deep .media-content .checkbox-circle label {
  line-height: 1.3em;
}
::ng-deep .media-content .checkbox-circle label::before {
  margin-left: -19px;
  outline: none;
}
::ng-deep .media-content .btn-success.btn-outline {
  color: rgb(105, 190, 40);
  border-color: rgb(105, 190, 40);
  max-width: 60%;
  margin: auto;
}
::ng-deep .media-content .btn-success.btn-outline:hover, ::ng-deep .media-content .btn-success.btn-outline:active, ::ng-deep .media-content .btn-success.btn-outline:focus {
  background-color: rgb(105, 190, 40);
  border-color: rgb(105, 190, 40);
  color: #fff;
}
::ng-deep .media-content .card-description p {
  color: #6d6e71;
}
::ng-deep .media-content .build-form {
  max-width: 60%;
  width: 100%;
  margin: 10px auto;
}
::ng-deep .media-content .build-form label {
  display: block;
  width: 100%;
}
::ng-deep .media-content .build-form label span {
  display: inline-block;
  margin: 2px;
  float: right;
}
::ng-deep .media-content .build-form label span:hover {
  cursor: pointer;
}
::ng-deep .media-content .build-form input {
  height: 33px;
  outline: none;
  border: 1px solid #888888;
  width: 100%;
  border-radius: 3px;
  text-indent: 10px;
  margin-bottom: 10px;
}
::ng-deep .media-content .build-form input:focus {
  border: 1px solid rgb(105, 190, 40);
}

::ng-deep .media-container .btn-develop {
  border: 1px solid rgb(105, 190, 40);
  background: rgb(105, 190, 40);
}
::ng-deep .media-container .btn-develop:hover, ::ng-deep .media-container .btn-develop:active, ::ng-deep .media-container .btn-develop:focus {
  background-color: #449d44;
  border: 1px solid #449d44;
  color: #fff;
}

::ng-deep .map-btn {
  /*color: \$develop-color;*/
  /*border-color: \$develop-color;*/
  max-width: 200px;
  margin: 40px auto 0px;
  width: 100%;
  display: block;
}
::ng-deep .map-btn.btn-develop:hover {
  border: 1px solid #449d44;
  background: #449d44;
}
::ng-deep .map-btn:hover, ::ng-deep .map-btn:active, ::ng-deep .map-btn:focus {
  background-color: rgb(105, 190, 40);
  border-color: rgb(105, 190, 40);
  color: #fff;
}

::ng-deep .media-content {
  padding-right: 40px;
}
::ng-deep .media-content .btn-develop {
  background: rgb(105, 190, 40);
  border-color: rgb(105, 190, 40);
}
::ng-deep .media-content .btn-develop:active, ::ng-deep .media-content .btn-develop:focus, ::ng-deep .media-content .btn-develop:hover {
  background: #449d44;
  border: 1px solid #449d44;
  color: #fff;
}
::ng-deep .media-content h2 a.grey-link {
  position: absolute;
  right: 10px;
}

::ng-deep .map-img {
  margin-top: 45px !important;
}

::ng-deep .work-modal {
  font-size: 14px;
}
::ng-deep .work-modal .btn-example {
  display: inline-block;
  cursor: pointer;
}
::ng-deep .work-modal .work-modal_popup {
  display: none;
}
::ng-deep .work-modal .work-modal_popup.active {
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9999;
}
::ng-deep .work-modal .work-modal_popup .popup_content {
  position: absolute;
  top: 50%;
  max-width: 600px;
  background: rgba(255, 255, 255, 0.9);
  left: 0;
  right: 0;
  font-size: 18px;
  padding: 20px;
  margin: auto;
  transform: translateY(-50%);
}
::ng-deep .work-modal .work-modal_popup .popup_content h3 {
  font-size: 24px;
}
::ng-deep .work-modal .work-modal_popup .popup_content .clx-example {
  position: absolute;
  right: -30px;
  top: -30px;
  display: inline-block;
  font-size: 24px;
  color: #fff;
  cursor: pointer;
}

::ng-deep .card-description p {
  font-size: 13px;
}
::ng-deep .card-description p strong {
  display: block;
  margin-bottom: 5px;
}

::ng-deep .activeBox {
  color: #48ac51 !important;
}

::ng-deep .user-profile-wrapper a {
  color: #333;
  text-decoration: underline;
}
::ng-deep .user-profile-wrapper a:hover, ::ng-deep .user-profile-wrapper a:focus, ::ng-deep .user-profile-wrapper a:active {
  color: #333;
  text-decoration: none;
}

::ng-deep .m-t-xs {
  padding-bottom: 50px;
}

::ng-deep .nav-header .thumbs img {
  max-width: 60%;
}

/*--- dashboard-new circles style ---*/
::ng-deep .dashboard-new {
  min-width: 755px;
  max-width: 755px;
  min-height: 525px;
  width: 95%;
  margin: 25px auto 0 auto;
  padding-top: 35px;
}
@media only screen and (max-width: 1023px) {
  body.dash-admin-3:not(.mini-navbar) ::ng-deep .dashboard-new {
    min-width: 510px;
  }
}
@media only screen and (max-width: 960px) {
  body.mini-navbar ::ng-deep .dashboard-new {
    min-width: 510px;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep .dashboard-new {
    min-width: 100% !important;
  }
}
::ng-deep .dashboard-new h1, ::ng-deep .dashboard-new p {
  margin: 0;
}
::ng-deep .dashboard-new .footer-images {
  padding: 25px 20px;
  margin-top: 20%;
  margin-bottom: 25px;
  display: table;
  width: 100%;
}
::ng-deep .dashboard-new .footer-images .col-xs-6 {
  padding: 0;
  line-height: 29px;
}
::ng-deep .dashboard-new .footer-images .col-xs-6 img {
  max-width: 100%;
  vertical-align: bottom;
}
@media only screen and (max-width: 767px) {
  ::ng-deep .dashboard-new .footer-images {
    margin-top: 20px;
  }
}
@media only screen and (min-width: 769px) and (max-width: 960px) {
  body.dash-admin-3:not(.mini-navbar) ::ng-deep .dashboard-new h1 {
    margin-top: 25px;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep .dashboard-new h1 {
    margin-top: 25px;
  }
}
@media only screen and (max-width: 600px) {
  ::ng-deep .dashboard-new h1 {
    font-size: 25px;
    margin-top: 0px;
  }
}
::ng-deep .dashboard-new .dashboard-inner-block {
  max-width: 670px;
  width: 95%;
  margin: 0 auto;
  padding: 0;
  position: relative;
}
::ng-deep .dashboard-new .dashboard-inner-block ul {
  padding: 0;
  margin: -80px 0 0 0;
  list-style: none;
  display: table;
  width: 100%;
  transition: all 300ms ease;
}
@media only screen and (min-width: 769px) and (max-width: 960px) {
  body.dash-admin-3:not(.mini-navbar) ::ng-deep .dashboard-new .dashboard-inner-block ul {
    margin-top: 25px;
    text-align: center;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep .dashboard-new .dashboard-inner-block ul {
    margin-top: 25px;
    text-align: center;
  }
}
::ng-deep .dashboard-new .dashboard-inner-block ul * {
  transition: all 300ms ease;
}
::ng-deep .dashboard-new .dashboard-inner-block ul li {
  max-width: 134px;
  min-height: 330px;
  line-height: 330px;
  float: none;
  display: table-cell;
  position: relative;
}
@media only screen and (min-width: 769px) and (max-width: 960px) {
  body.dash-admin-3:not(.mini-navbar) ::ng-deep .dashboard-new .dashboard-inner-block ul li {
    display: inline-block;
    width: 50%;
    min-height: 200px;
    line-height: 200px;
    margin-bottom: 25px;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep .dashboard-new .dashboard-inner-block ul li {
    display: inline-block;
    width: 100%;
    max-width: 100%;
    min-height: inherit;
    line-height: inherit;
    margin-bottom: 25px;
  }
  ::ng-deep .dashboard-new .dashboard-inner-block ul li:first-child, ::ng-deep .dashboard-new .dashboard-inner-block ul li:last-child {
    min-height: initial !important;
    line-height: initial !important;
  }
  ::ng-deep .dashboard-new .dashboard-inner-block ul li:last-child {
    margin-bottom: 35px;
  }
}
@media only screen and (max-width: 413px) {
  body.mini-navbar ::ng-deep .dashboard-new .dashboard-inner-block ul li {
    width: 100%;
  }
}
::ng-deep .dashboard-new .dashboard-inner-block ul li * {
  line-height: normal;
}
::ng-deep .dashboard-new .dashboard-inner-block ul li .circle {
  display: inline-block;
  vertical-align: bottom;
  background-color: #fab254;
  border-radius: 50%;
  width: 108px;
  height: 108px;
  line-height: 108px;
  text-align: center;
  position: relative;
  -ms-box-shadow: 0px 5px 25px -3px #676a6c;
  -o-box-shadow: 0px 5px 25px -3px #676a6c;
  box-shadow: 0px 5px 25px -3px #676a6c;
  cursor: pointer;
}
::ng-deep .dashboard-new .dashboard-inner-block ul li .circle:hover, ::ng-deep .dashboard-new .dashboard-inner-block ul li .circle:focus {
  -ms-box-shadow: 0px 0px 20px -3px #676a6c;
  -o-box-shadow: 0px 0px 20px -3px #676a6c;
  box-shadow: 0px 0px 20px -3px #676a6c;
}
::ng-deep .dashboard-new .dashboard-inner-block ul li .circle:hover .fa, ::ng-deep .dashboard-new .dashboard-inner-block ul li .circle:focus .fa {
  color: #293846;
}
::ng-deep .dashboard-new .dashboard-inner-block ul li .circle:after {
  content: "";
  border: 1px solid #db6e57;
  width: 50px;
  display: inline-block;
  position: absolute;
  right: -48px;
  top: 40%;
  transform: translate(0%, -50%) rotate(-25deg);
}
@media only screen and (max-width: 767px) {
  ::ng-deep .dashboard-new .dashboard-inner-block ul li .circle:after {
    transform: translate(0%, -50%) rotate(90deg) !important;
    right: 29px !important;
    bottom: -26px;
    top: inherit !important;
  }
}
::ng-deep .dashboard-new .dashboard-inner-block ul li .circle.circle2 {
  margin-bottom: 20px;
}
::ng-deep .dashboard-new .dashboard-inner-block ul li .circle.circle2:after {
  right: -48px;
  top: 40%;
  transform: translate(0%, -50%) rotate(-25deg);
}
::ng-deep .dashboard-new .dashboard-inner-block ul li .circle.circle3 {
  margin-bottom: 60px;
}
::ng-deep .dashboard-new .dashboard-inner-block ul li .circle.circle3:after {
  right: -42px;
  top: 17%;
  transform: translate(0%, -50%) rotate(-35deg);
}
::ng-deep .dashboard-new .dashboard-inner-block ul li .circle.circle4 {
  margin-bottom: 140px;
}
::ng-deep .dashboard-new .dashboard-inner-block ul li .circle.circle4:after {
  right: -42px;
  top: 17%;
  transform: translate(0%, -50%) rotate(-35deg);
}
::ng-deep .dashboard-new .dashboard-inner-block ul li .circle.circle5 {
  vertical-align: top;
}
::ng-deep .dashboard-new .dashboard-inner-block ul li .circle.circle5:after {
  content: none;
}
@media only screen and (min-width: 769px) and (max-width: 960px) {
  body.dash-admin-3:not(.mini-navbar) ::ng-deep .dashboard-new .dashboard-inner-block ul li .circle {
    vertical-align: top;
  }
  body.dash-admin-3:not(.mini-navbar) ::ng-deep .dashboard-new .dashboard-inner-block ul li .circle:after {
    right: -50px;
    top: 50%;
    transform: translate(0%, -50%) rotate(0deg);
  }
  body.dash-admin-3:not(.mini-navbar) ::ng-deep .dashboard-new .dashboard-inner-block ul li .circle.circle2, body.dash-admin-3:not(.mini-navbar) ::ng-deep .dashboard-new .dashboard-inner-block ul li .circle.circle3, body.dash-admin-3:not(.mini-navbar) ::ng-deep .dashboard-new .dashboard-inner-block ul li .circle.circle4, body.dash-admin-3:not(.mini-navbar) ::ng-deep .dashboard-new .dashboard-inner-block ul li .circle.circle5 {
    margin: 0;
  }
  body.dash-admin-3:not(.mini-navbar) ::ng-deep .dashboard-new .dashboard-inner-block ul li .circle.circle4:after {
    content: none;
  }
  body.dash-admin-3:not(.mini-navbar) ::ng-deep .dashboard-new .dashboard-inner-block ul li .circle.circle5 {
    vertical-align: top;
  }
}
@media only screen and (min-width: 769px) and (max-width: 863px) {
  body.dash-admin-3:not(.mini-navbar) ::ng-deep .dashboard-new .dashboard-inner-block ul li .circle.circle3:after {
    content: none;
  }
  body.dash-admin-3:not(.mini-navbar) ::ng-deep .dashboard-new .dashboard-inner-block ul li .circle.circle4:after {
    content: "";
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep .dashboard-new .dashboard-inner-block ul li .circle {
    vertical-align: top;
  }
  ::ng-deep .dashboard-new .dashboard-inner-block ul li .circle.circle2, ::ng-deep .dashboard-new .dashboard-inner-block ul li .circle.circle3, ::ng-deep .dashboard-new .dashboard-inner-block ul li .circle.circle4, ::ng-deep .dashboard-new .dashboard-inner-block ul li .circle.circle5 {
    margin: 0;
  }
  ::ng-deep .dashboard-new .dashboard-inner-block ul li .circle.circle5 {
    vertical-align: top;
  }
}
::ng-deep .dashboard-new .dashboard-inner-block ul li .circle a {
  display: inline-block;
  vertical-align: middle;
}
::ng-deep .dashboard-new .dashboard-inner-block ul li .circle a h4 {
  line-height: 1;
  font-size: 12px;
  color: #000;
  font-family: "MuseoSans-300";
}
::ng-deep .dashboard-new .dashboard-inner-block ul li .circle a h4 span {
  display: block;
}
::ng-deep .dashboard-new .dashboard-inner-block ul li .circle .fa {
  font-size: 18px !important;
  color: #fff;
}
::ng-deep .dashboard-new .dashboard-inner-block ul li .sub-circle {
  width: 74px;
  height: 74px;
  line-height: 74px;
  background-color: #db6e57;
  border-radius: 50%;
  text-align: center;
  position: absolute;
  bottom: -71px;
  left: -20px;
  right: 0;
  margin: 0 auto;
  -ms-box-shadow: 0px 3px 10px -3px #676a6c;
  -o-box-shadow: 0px 3px 10px -3px #676a6c;
  box-shadow: 0px 3px 10px -3px #676a6c;
}
@media only screen and (min-width: 769px) and (max-width: 960px) {
  body.dash-admin-3:not(.mini-navbar) ::ng-deep .dashboard-new .dashboard-inner-block ul li .sub-circle {
    bottom: 0px;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep .dashboard-new .dashboard-inner-block ul li .sub-circle {
    bottom: -55px;
    left: 0px;
    right: 200px;
  }
}
@media only screen and (max-width: 413px) {
  body.mini-navbar ::ng-deep .dashboard-new .dashboard-inner-block ul li .sub-circle {
    left: 0px !important;
  }
}
::ng-deep .dashboard-new .dashboard-inner-block ul li .sub-circle:before {
  content: "";
  height: 18px;
  border: 1px solid #db6e57;
  width: 1px;
  margin: 0 auto;
  display: inline-block;
  position: absolute;
  left: 0;
  right: 0;
  top: -17px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep .dashboard-new .dashboard-inner-block ul li .sub-circle:before {
    height: 45px !important;
    top: -20px !important;
    right: -75px !important;
    transform: rotate(50deg) !important;
    z-index: -1;
  }
}
::ng-deep .dashboard-new .dashboard-inner-block ul li .sub-circle a {
  display: inline-block;
  vertical-align: middle;
}
::ng-deep .dashboard-new .dashboard-inner-block ul li .sub-circle a h6 {
  line-height: 1;
  font-size: 11px;
  margin: 0 0 5px 0;
  color: #fff;
  font-family: "MuseoSans-300";
}
::ng-deep .dashboard-new .dashboard-inner-block ul li .sub-circle a h6 span {
  display: block;
}
::ng-deep .dashboard-new .dashboard-inner-block ul li .sub-circle .fa {
  font-size: 18px !important;
  color: #fff;
}
::ng-deep .dashboard-new .dashboard-inner-block ul li .sub-circle.sub-circle2 {
  margin-bottom: 40px;
  left: 20px;
}
@media only screen and (min-width: 769px) and (max-width: 960px) {
  body.dash-admin-3:not(.mini-navbar) ::ng-deep .dashboard-new .dashboard-inner-block ul li .sub-circle.sub-circle2 {
    left: 0px;
    margin-bottom: 0;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep .dashboard-new .dashboard-inner-block ul li .sub-circle.sub-circle2 {
    left: 0px;
    margin-bottom: 0;
  }
}
::ng-deep .dashboard-new .dashboard-inner-block ul li .sub-circle.sub-circle2:before {
  left: -20px;
  transform: rotate(-20deg);
  -webkit-transform: rotate(-20deg);
  -moz-transform: rotate(-20deg);
}
@media only screen and (min-width: 769px) and (max-width: 960px) {
  body.dash-admin-3:not(.mini-navbar) ::ng-deep .dashboard-new .dashboard-inner-block ul li .sub-circle.sub-circle2:before {
    left: 0px;
    transform: none;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep .dashboard-new .dashboard-inner-block ul li .sub-circle.sub-circle2:before {
    left: 0px;
    transform: none;
  }
}
::ng-deep .dashboard-new .dashboard-inner-block ul li .sub-circle.sub-circle3 {
  margin-bottom: 120px;
  left: 40px;
}
@media only screen and (min-width: 769px) and (max-width: 960px) {
  body.dash-admin-3:not(.mini-navbar) ::ng-deep .dashboard-new .dashboard-inner-block ul li .sub-circle.sub-circle3 {
    left: 0px;
    margin-bottom: 0;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep .dashboard-new .dashboard-inner-block ul li .sub-circle.sub-circle3 {
    left: 0px;
    margin-bottom: 0;
  }
}
::ng-deep .dashboard-new .dashboard-inner-block ul li .sub-circle.sub-circle3:before {
  left: -30px;
  height: 23px;
  top: -18px;
  transform: rotate(-25deg);
}
@media only screen and (min-width: 769px) and (max-width: 960px) {
  body.dash-admin-3:not(.mini-navbar) ::ng-deep .dashboard-new .dashboard-inner-block ul li .sub-circle.sub-circle3:before {
    left: 0px;
    height: 18px;
    top: -17px;
    transform: none;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep .dashboard-new .dashboard-inner-block ul li .sub-circle.sub-circle3:before {
    left: 0px;
    height: 18px;
    top: -17px;
    transform: none;
  }
}

::ng-deep .dash-admin-2 .dashboard-new h1 {
  font-family: "Museo-700";
  color: #fff;
}
::ng-deep .dash-admin-2 .dashboard-new p {
  color: #fff;
  font-family: "Museo-300";
  font-weight: normal;
}

/* iCheck plugin Square skin, green
----------------------------------- */
.icheckbox_square-green,
.iradio_square-green {
  display: inline-block;
  *display: inline;
  vertical-align: middle;
  margin: 0;
  padding: 0;
  width: 22px;
  height: 22px;
  border: none;
  cursor: pointer;
}

.icheckbox_square-green {
  background-position: 0 0;
}

.icheckbox_square-green.hover {
  background-position: -24px 0;
}

.icheckbox_square-green.checked {
  background-position: -48px 0;
}

.icheckbox_square-green.disabled {
  background-position: -72px 0;
  cursor: default;
}

.icheckbox_square-green.checked.disabled {
  background-position: -96px 0;
}

.iradio_square-green {
  background-position: -120px 0;
}

.iradio_square-green.hover {
  background-position: -144px 0;
}

.iradio_square-green.checked {
  background-position: -168px 0;
}

.iradio_square-green.disabled {
  background-position: -192px 0;
  cursor: default;
}

.iradio_square-green.checked.disabled {
  background-position: -216px 0;
}

/* HiDPI support */
@media (min-resolution: 120dpi) {
  .icheckbox_square-green,
  .iradio_square-green {
    background-size: 240px 24px;
  }
}
::ng-deep .learner-rating {
  max-width: 230px;
  margin: 0 auto;
  margin-top: 25px;
}
::ng-deep .learner-rating .inner-learner-rating > div {
  display: inline-block;
  float: left;
  margin: 0 12px;
}
::ng-deep .learner-rating .text-label {
  margin-left: 10px;
  margin-right: 10px;
  font-size: 12px;
}

::ng-deep .rating-wrap .build-form {
  max-width: 350px !important;
}
::ng-deep .rating-wrap .build-form h3 {
  font-size: 16px;
  line-height: 1.2em;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/app/components/learner-maps/toolset/toolset.component.scss"],"names":[],"mappings":"AAgIA;EACE,eAAA;AC/HF;;ADkIA;EACE,aAAA;EACA,eAAA;AC/HF;;ADkIA;EACE,sBAAA;AC/HF;;ADkIA;EACE,8BAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,aAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;AD6IE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;AC1IJ;AD4II;;;;;;EACE,gBAAA;ACrIN;ADyIE;;EAEE,eA5GO;EA6GP,gBA3GO;AC5BX;ADyII;EALF;;IAMI,eA/GY;ECtBhB;AACF;ADwIE;;EAEE,eAlHO;EAmHP,gBAjHO;ACrBX;ADwII;EALF;;IAMI,eArHY;ECfhB;AACF;ADuIE;;EAEE,eAxHO;EAyHP,gBAvHO;ACdX;ADuII;EALF;;IAMI,eA3HY;ECRhB;AACF;ADsIE;;EAEE,eA9HO;EA+HP,gBA7HO;ACPX;ADuIE;;EAEE,eAhIO;EAiIP,gBAhIO;ACLX;ADwIE;;EAEE,eAnIO;EAoIP,gBAnIO;ACHX;AD4IE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;AC1IJ;AD4II;EACE,gBAAA;AC1IN;AD6II;EAXF;IAYI,eAAA;EC1IJ;AACF;AD6IE;;EAEE,UAAA;EACA,SAAA;AC3IJ;AD8IE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;AC5IJ;;ADgJA;EACE,sBAxNQ;AC2EV;;ADgJA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;AC7IF;AD+IE;EALF;IAMI,cAAA;EC5IF;AACF;AD8IE;EACE,iBA1Ka;AC8BjB;AD+IE;EACE,gBApLa;EAqLb,WAAA;AC7IJ;;ADkJE;EACE,kBAAA;AC/IJ;ADkJE;EACE,iBAAA;AChJJ;;ADqJE;EACE,aAAA;AClJJ;;ADsJA;EACE,kBAAA;ACnJF;ADqJE;EACE,mBAAA;ACnJJ;ADuJI;EACE,sBAAA;ACrJN;ADyJE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;ACuEnB;ADyJI;EACE,sBAAA;ACvJN;AD0JI;EAVF;IAWI,eApOoB;EC6ExB;AACF;AD0JE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;ACxJJ;AD0JI;EACE,sBAAA;ACxJN;AD2JI;EACE,WAAA;ACzJN;AD4JI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;ACkMZ;;AD+JA;EACE,mBA1PO;AC8FT;AD8JE;EAHF;IAII,mBAAA;EC3JF;AACF;AD6JE;EACE,mBAAA;AC3JJ;AD8JE;EACE,aArQK;ACyGT;AD8JI;EAHF;IAII,aAAA;EC3JJ;AACF;AD6JI;EACE,aAAA;AC3JN;;ADgKA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;AC7JF;AD+JE;EACE,eAAA;AC7JJ;ADgKE;EACE,sCAAA;AC9JJ;ADiKE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;AC/JJ;;AD8KE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;AC3KJ;AD6KI;EACE,kBAAA;AC3KN;AD8KI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;AC5KN;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,+BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;AC9KF;ADgLE;EACE,2BAAA;EACA,mBAAA;AC9KJ;ADiLE;EACE,yBAzbiB;EA0bjB,WA1aO;AC2PX;ADkLE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;AChLJ;ADmLE;EACE,yBAjckB;EAkclB,cArciB;ACoRrB;ADoLE;EACE,yBAvbS;EAwbT,WA1bO;ACwQX;ADoLI;EACE,6BAAA;AClLN;;ADuLA;EACE;IACE,uBAAA;ECpLF;EDuLA;IACE,yBAAA;ECrLF;AACF;ADwLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,+BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,qBAAA;ACtLF;;ADyLA;EACE,UAAA;ACtLF;ADwLE;EACE,qBAAA;ACtLJ;;AD0LA;EACE,UAAA;ACvLF;;AD2LE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;ACzLJ;AD4LM;EACE,mBAAA;AC1LR;AD+LE;EACE,2BAAA;AC7LJ;ADgME;EACE,uBAAA;AC9LJ;ADiME;EACE,mBAAA;AC/LJ;;ADoME;EACE,mBAAA;ACjMJ;ADoME;EACE,yBAAA;AClMJ;ADqME;EACE,sBAAA;ACnMJ;ADsME;EACE,uBAAA;ACpMJ;ADuME;EACE,oBAAA;ACrMJ;;AA3YE;EACE;cAAA;AA+YJ;AA5YM;EACE,kBAAA;AA8YR;AA3YM;EALF;IAMI,UAAA;EA8YN;AACF;AA5YM;EATF;IAUI,WAAA;EA+YN;EA9YM;IACE,mBAAA;EAgZR;AACF;AA3YE;EACE,UAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;AA6YJ;AA3YI;EAPF;IAQI,iBAAA;EA8YJ;AACF;AA5YI;EACE,WAAA;EACA,iBAAA;EACA,mBAAA;AA8YN;AA5YM;EALF;IAMI,UAAA;IACA,iBAAA;EA+YN;AACF;AA7YM;EAVF;IAWI,gBAAA;IACA,YAAA;IACA,UAAA;IACA,iBAAA;EAgZN;AACF;;AAzYA,qCAAA;AAEA,yBAAA;AAGE;EACE,kBAAA;AAyYJ;AArYM;EACE,YAAA;EACA,mCAAA;AAuYR;AApYM;EACE,cAAA;AAsYR;AAlYI;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;EACA,UAAA;AAoYN;AAhYQ;EACE,YAAA;EACA,mCAAA;AAkYV;AAhYU;EACE,cAAA;AAkYZ;AA9XQ;EACE,cAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;AAgYV;AA/XU;EALF;IAMI,OAAA;IACA,QAAA;IACA,iBAAA;IACA,kBAAA;IACA,gBAAA;IACA,eAAA;IACA,WAAA;EAkYV;AACF;AAhYU;EACE,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,4BAAA;EACA,wCAAA;EACA,UAAA;AAkYZ;AAhYY;EACE,YAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,4BAAA;AAkYd;;AAxXE;EACE;IACE,cAAA;IACA,qBAAA;EA2XJ;AACF;;AAvXA;EACE,4CAAA;EACA,iDAAA;EACA,oDAAA;EAEA,gCAAA;EACA,sBAAA;AAyXF;AAvXE;EACE,2BAAA;AAyXJ;;AArXA,cAAA;AAQM;EACE,4BAAA;AAiXR;AA/WQ;EAHF;IAII,4BAAA;EAkXR;AACF;AAhXQ;EAKE,gBAAA;EACA,cAAA;EACA,WAAA;AA8WV;AApXU;EACE,UAAA;AAsXZ;AA/WU;EACE,eAAA;AAiXZ;AA9WU;EACE,kBAAA;AAgXZ;;AAvWA;EACE,cAAA;EACA,WAAA;EACA,kBAAA;AA0WF;;AAvWA;EACE,kBAAA;EACA,eAAA;AA0WF;AAzWE;EAHF;IAII,eAAA;IACA,gBAAA;EA4WF;AACF;AA3WE;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;EACA,8BAAA;EACA,cAAA;AA6WJ;AA3WI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;AA6WN;;AAvWE;EACE,eAAA;AA0WJ;AAvWE;EACE,8BAAA;AAyWJ;AAvWI;EAHF;IAII,8BAAA;EA0WJ;AACF;AAtWE;EACE,YAAA;EACA,sBAAA;EACA,gBAAA;EACA,eAAA;AAwWJ;AAtWI;EANF;IAOI,WAAA;EAyWJ;AACF;;AArWA;EACG,gBAAA;AAwWH;AAtWE;EACE,YAAA;EACA,0BAAA;EACA,6BAAA;EAGA,YAAA;EACA,WAAA;EACA,gBAAA;AAsWJ;AAlWE;EACE,eAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;AAoWJ;AAlWI;EACE,kBAAA;AAoWN;AAjWI;EACE,kBAAA;EACA,aAAA;AAmWN;AA/VE;EACE,wBDrQY;ECsQZ,+BDtQY;ECuQZ,cAAA;EACA,YAAA;AAiWJ;AA/VI;EACE,mCD3QU;EC4QV,+BD5QU;EC6QV,WD7Na;AC8jBnB;AA7VE;EAGE,cDnQiB;ACgmBrB;AA3VE;EACE,cAAA;EACA,WAAA;EACA,iBAAA;AA6VJ;AA3VI;EACE,cAAA;EACA,WAAA;AA6VN;AA3VM;EACE,qBAAA;EACA,WAAA;EACA,YAAA;AA6VR;AA3VQ;EACE,eAAA;AA6VV;AAxVI;EACE,YAAA;EACA,aAAA;EACA,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;AA0VN;AAxVM;EACE,mCAAA;AA0VR;;AAlVE;EACE,mCAAA;EACA,6BD9TY;ACmpBhB;AAnVI;EACE,yBAAA;EACA,yBAAA;EACA,WDnRa;ACwmBnB;;AA/UA;EACE,yBAAA;EACA,gCAAA;EACA,gBAAA;EACA,qBAAA;EACA,WAAA;EACA,cAAA;AAkVF;AAjVE;EACE,yBAAA;EACA,mBAAA;AAmVJ;AAhVE;EACE,mCDtVY;ECuVZ,+BDvVY;ECwVZ,WDxSe;AC0nBnB;;AA9UA;EACE,mBAAA;AAiVF;AA/UE;EACE,6BDhWY;ECiWZ,+BDjWY;ACkrBhB;AA/UI;EACE,mBAAA;EACA,yBAAA;EACA,WDtTa;ACuoBnB;AA5UI;EACE,kBAAA;EACA,WAAA;AA8UN;;AAzUA;EACE,2BAAA;AA4UF;;AAzUA;EACE,eAAA;AA4UF;AA1UE;EACE,qBAAA;EACA,eAAA;AA4UJ;AAzUE;EACE,aAAA;AA2UJ;AAzUI;EACE,cAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,aAAA;AA2UN;AAxUI;EACE,kBAAA;EACA,QAAA;EACA,gBAAA;EACA,oCAAA;EACA,OAAA;EACA,QAAA;EACA,eAAA;EACA,aAAA;EACA,YAAA;EAGA,2BAAA;AA0UN;AAxUM;EACE,eAAA;AA0UR;AAvUM;EACE,kBAAA;EACA,YAAA;EACA,UAAA;EACA,qBAAA;EACA,eAAA;EACA,WDpXW;ECqXX,eAAA;AAyUR;;AAlUE;EACE,eAAA;AAqUJ;AAnUI;EACE,cAAA;EACA,kBAAA;AAqUN;;AAhUA;EACE,yBAAA;AAmUF;;AAhUA;EACE,WAAA;EACA,0BAAA;AAmUF;AAlUE;EACE,WAAA;EACA,qBAAA;AAoUJ;;AAhUA;EACE,oBAAA;AAmUF;;AAhUA;EACE,cAAA;AAmUF;;AA9TA,sCAAA;AACA;EACE,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,UAAA;EACA,wBAAA;EAQA,iBAAA;AA0TF;AAxTE;EACE;IACE,gBAAA;EA0TJ;AACF;AAvTE;EACE;IACE,gBAAA;EAyTJ;AACF;AAtTE;EA3BF;IA4BI,0BAAA;EAyTF;AACF;AArTE;EACE,SAAA;AAuTJ;AAjTE;EAEE,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;EACA,WAAA;AAkTJ;AAjTI;EACE,UAAA;EACA,iBAAA;AAmTN;AAlTM;EACE,eAAA;EACA,sBAAA;AAoTR;AAjTI;EAfF;IAgBI,gBAAA;EAoTJ;AACF;AA3SI;EACE;IACE,gBAAA;EA6SN;AACF;AA1SI;EATF;IAUI,gBAAA;EA6SJ;AACF;AA3SI;EAbF;IAcI,eAAA;IACA,eAAA;EA8SJ;AACF;AA3SE;EACE,gBAAA;EACA,UAAA;EACA,cAAA;EACA,UAAA;EACA,kBAAA;AA6SJ;AA3SI;EACE,UAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,WAAA;EAkBA,0BAAA;AAgSN;AAhTM;EACE;IACE,gBAAA;IACA,kBAAA;EAkTR;AACF;AA/SM;EAdF;IAeI,gBAAA;IACA,kBAAA;EAkTN;AACF;AA1SM;EAKE,0BAAA;AA4SR;AAzSM;EACE,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;AA2SR;AAzSQ;EACE;IACE,qBAAA;IACA,UAAA;IACA,iBAAA;IACA,kBAAA;IACA,mBAAA;EA2SV;AACF;AAxSQ;EAlBF;IAmBI,qBAAA;IACA,WAAA;IACA,eAAA;IAGA,mBAAA;IACA,oBAAA;IACA,mBAAA;EAySR;EAvSQ;IACE,8BAAA;IACA,+BAAA;EAySV;EAvSQ;IACE,mBAAA;EAySV;AACF;AAtSQ;EACE;IACE,WAAA;EAwSV;AACF;AArSQ;EACE,mBAAA;AAuSV;AApSQ;EACE,qBAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EAGA,yCAAA;EACA,wCAAA;EACA,qCAAA;EACA,eAAA;AAsSV;AApSU;EAGE,yCAAA;EACA,wCAAA;EACA,qCAAA;AAsSZ;AApSY;EACE,cAAA;AAsSd;AAlSU;EACE,WAAA;EACA,yBAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,YAAA;EACA,QAAA;EACA,6CAAA;AAoSZ;AAlSY;EAVF;IAYI,uDAAA;IACA,sBAAA;IACA,aAAA;IACA,uBAAA;EAoSZ;AACF;AAjSU;EACE,mBAAA;AAmSZ;AAjSY;EACE,YAAA;EACA,QAAA;EACA,6CAAA;AAmSd;AA/RU;EACE,mBAAA;AAiSZ;AAhSY;EACE,YAAA;EACA,QAAA;EACA,6CAAA;AAkSd;AA9RU;EACE,oBAAA;AAgSZ;AA/RY;EACE,YAAA;EACA,QAAA;EACA,6CAAA;AAiSd;AA7RU;EACE,mBAAA;AA+RZ;AA9RY;EACE,aAAA;AAgSd;AA5RU;EACE;IACE,mBAAA;EA8RZ;EA5RY;IACE,YAAA;IACA,QAAA;IACA,2CAAA;EA8Rd;EA3RY;IACE,SAAA;EA6Rd;EAzRc;IACE,aAAA;EA2RhB;EAvRY;IACE,mBAAA;EAyRd;AACF;AArRU;EAGM;IACE,aAAA;EAqRhB;EAjRc;IACE,WAAA;EAmRhB;AACF;AA9QU;EA5HF;IA6HI,mBAAA;EAiRV;EA/QU;IACE,SAAA;EAiRZ;EA9QU;IACE,mBAAA;EAgRZ;AACF;AA7QU;EACE,qBAAA;EACA,sBAAA;AA+QZ;AA9QY;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,4BDtxBF;ACsiCZ;AA/Qc;EACE,cAAA;AAiRhB;AA3QU;EACE,0BAAA;EACA,WDhuBO;AC6+BnB;AAzQQ;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,WAAA;EACA,QAAA;EACA,cAAA;EAGA,yCAAA;EACA,wCAAA;EACA,qCAAA;AA2QV;AAzQU;EACE;IACE,WAAA;EA2QZ;AACF;AAxQU;EAxBF;IAyBI,aAAA;IACA,SAAA;IACA,YAAA;EA2QV;AACF;AAzQU;EACE;IACE,oBAAA;EA2QZ;AACF;AAxQU;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,UAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,UAAA;AA0QZ;AAzQY;EAXF;IAYI,uBAAA;IACA,qBAAA;IACA,uBAAA;IACA,mCAAA;IACA,WAAA;EA4QZ;AACF;AAzQU;EACE,qBAAA;EACA,sBAAA;AA2QZ;AA1QY;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,WDnyBK;ECoyBL,4BDp2BF;ACgnCZ;AA3Qc;EACE,cAAA;AA6QhB;AAvQU;EACE,0BAAA;EACA,WD9yBO;ACujCnB;AAtQU;EACE,mBAAA;EACA,UAAA;AAwQZ;AAvQY;EACI;IACE,SAAA;IACA,gBAAA;EAyQhB;AACF;AAtQY;EAVF;IAWI,SAAA;IACA,gBAAA;EAyQZ;AACF;AAvQY;EACE,WAAA;EACA,yBAAA;EACA,iCAAA;EACA,8BAAA;AAyQd;AAxQc;EACE;IACE,SAAA;IACA,eAAA;EA0QhB;AACF;AAvQc;EAZF;IAaI,SAAA;IACA,eAAA;EA0Qd;AACF;AAtQU;EACE,oBAAA;EACA,UAAA;AAwQZ;AAvQY;EACI;IACE,SAAA;IACA,gBAAA;EAyQhB;AACF;AAtQY;EAVF;IAWI,SAAA;IACA,gBAAA;EAyQZ;AACF;AAvQY;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,yBAAA;AAyQd;AAxQc;EACE;IACE,SAAA;IACA,YAAA;IACA,UAAA;IACA,eAAA;EA0QhB;AACF;AAvQc;EAdF;IAeI,SAAA;IACA,YAAA;IACA,UAAA;IACA,eAAA;EA0Qd;AACF;;AAhQE;EACE,wBDl8BO;ECm8BP,WDj4Be;ACooCnB;AAjQE;EACE,WDp4Be;ECq4Bf,wBD18BO;EC28BP,mBAAA;AAmQJ;;AA/PA;qCAAA;AAEA;;EAEI,qBAAA;GAkQF,eAjQE;EACA,sBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EAEA,YAAA;EACA,eAAA;AAiQJ;;AA9PA;EACI,wBAAA;AAiQJ;;AA/PA;EACI,4BAAA;AAkQJ;;AAhQA;EACI,4BAAA;AAmQJ;;AAjQA;EACI,4BAAA;EACA,eAAA;AAoQJ;;AAlQA;EACI,4BAAA;AAqQJ;;AAlQA;EACI,6BAAA;AAqQJ;;AAnQA;EACI,6BAAA;AAsQJ;;AApQA;EACI,6BAAA;AAuQJ;;AArQA;EACI,6BAAA;EACA,eAAA;AAwQJ;;AAtQA;EACI,6BAAA;AAyQJ;;AAtQA,kBAAA;AACA;EACI;;IAII,2BAAA;EAwQN;AACF;AApQA;EACE,gBAAA;EACA,cAAA;EACA,gBAAA;AAsQF;AAnQI;EACE,qBAAA;EACA,WAAA;EACA,cAAA;AAqQN;AAjQE;EACE,iBAAA;EACA,kBAAA;EACA,eAAA;AAmQJ;;AA9PE;EACE,2BAAA;AAiQJ;AA/PI;EACE,eAAA;EACA,kBAAA;AAiQN","sourcesContent":["// Font\n$font-stack: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n$muso-100: \"Museo-100\";\n$muso-300: \"Museo-300\";\n$muso-300-i: \"Museo-300Italic\";\n$muso-500: \"Museo-regular\";\n$muso-700: \"Museo-700\";\n$muso-700-i: \"Museo-700Italic\";\n$muso-sans: \"MuseoSans-300\";\n$car-font: \"Marydale\";\n$car-big-font: \"Bangers\", cursive;\n$font-museo: \"Conv_museo-500-webfont\";\n$font-helvetica: \"Helvetica\", \"open sans\";\n$MuseoSansCondensed-300: \"MuseoSansCondensed-300\";\n\n$fwBold: 700;\n\n//Foursight\n// $clarify-color: #06A6CE;\n// $ideate-color: #FF8300;\n// $develop-color: #7BBC43;\n// $implement-color: #FF485C;\n$clarify-color: rgba(0, 173, 208, 1);\n$ideate-color: rgba(255, 121, 0, 1);\n$develop-color: rgba(105, 190, 40, 1);\n$implement-color: rgba(245, 67, 89, 1);\n$low-clarify-color: rgba(0, 173, 208, 1);\n$low-ideate-color: rgba(255, 121, 0, 1);\n$low-develop-color: rgba(105, 190, 40, 1);\n$low-implement-color: rgba(245, 67, 89, 1);\n$profile-connector-color: #656668;\n// Profile Neutral color\n$integrator-color: #e3e3e3;\n// Team Report\n$report-integrator: #a7a7a7;\n// Body text color in reports\n$body-content-color: #676a6c;\n// Learner Map\n$gray-lm: rgba(0, 0, 0, 0.2);\n$border-color: #aaa;\n\n$color-neutral-dark: #6d6e71;\n$color-neutral-dark-500: #6a6a6a;\n$color-neutral-mid: #ccc;\n$color-neutral-light: #f1f1f2;\n$color-neutral-mid-old: #9e9e97;\n$color-dark-green: #4cae4c;\n$color-light-grey: #d9d9d9;\n$color-red: #ff485c;\n\n$color-grey-1: #e7eaec;\n\n$clrGray1: #f6f6f6;\n\n$clrDarkGray1: #ddd;\n\n$clrGrey: #eee;\n$clrWhite: #fff;\n$clrBlack: #000;\n$clrWarning: #f8ac59;\n\n$assets: \"https://assets.foursightonline.com/app\";\n$adminUpload: \"https://assets.foursightonline.com/admin-uploads/docs/\";\n\n$separator: \"\\//\";\n\n$active-class: #017ebc;\n\n// anchor Tag\n$anchor-color: #337ab7;\n\n//Sidebar\n$color-light-type: #fff;\n// submenu background\n$fs-dark-grey: #464646;\n// Hover\n$fs-active-light: #5f5f63;\n$fs-sidenav-bg: #333333;\n$fs-sidenav-hov-bg: #3e3e3f;\n$fs-green: #69be28;\n\n$clrInputAccent: #639935;\n\n$fn-fs-h1: 44px;\n$fn-fs-h1-mobile: 38px;\n$fn-lh-h1: 1.1;\n\n$fn-fs-h2: 38px;\n$fn-fs-h2-mobile: 32px;\n$fn-lh-h2: 1.2;\n\n$fn-fs-h3: 32px;\n$fn-fs-h3-mobile: 24px;\n$fn-lh-h3: 1.2;\n\n$fn-fs-h4: 24px;\n$fn-fs-h4-mobile: 20px;\n$fn-lh-h4: 1.2;\n\n$fn-fs-h5: 18px;\n$fn-lh-h5: 1.2;\n\n$fn-fs-h6: 16px;\n$fn-lh-h6: 1.3;\n\n$fn-title-subtext: 22px;\n$fn-title-subtext-mobile: 18px;\n\n$pageWidth: 1080px;\n$pageWidthSmall: 820px;\n$pageWidthFluid: 1200px;\n\n$secPad: 60px;\n\n$pageWidth: 1080px;\n$pageWidthFluid: 1200px;\n\n$desktop: \"only screen and (max-width: 1600px)\";\n$mac: \"only screen and (max-width: 1350px)\";\n$pc-up: \"only screen and (min-width: 1200px)\";\n$pc: \"only screen and (max-width: 1199px)\";\n$tablet-up: \"only screen and (min-width: 992px)\";\n$tablet: \"only screen and (max-width: 991px)\";\n$mobile-up: \"only screen and (min-width: 768px)\";\n$mobile: \"only screen and (max-width: 767px)\";\n$xl: \"only screen and (max-width: 1440px)\";\n$xl-up: \"only screen and (min-width: 1440px)\";\n\nimg {\n  max-width: 100%;\n}\n\n.flex {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.dir-col {\n  flex-direction: column;\n}\n\n.dir-col-rev {\n  flex-direction: column-reverse;\n}\n\n.mh-full {\n  min-height: 100%;\n}\n\n.mt-auto {\n  margin-top: auto;\n}\n\n.bt-0 {\n  border-top: 0;\n}\n\n.bb-0 {\n  border-bottom: 0;\n}\n\n@mixin headingfont() {\n  font-family: $muso-700 !important;\n  font-weight: normal !important;\n}\n\n@mixin contentfont() {\n  font-family: $muso-300 !important;\n  font-weight: normal !important;\n}\n\n.fn-body {\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    --hGap: 10px;\n    font-family: $muso-700;\n    color: $color-neutral-dark;\n    margin-bottom: var(--hGap);\n    margin-top: 0;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  h1,\n  .h1-text {\n    font-size: $fn-fs-h1;\n    line-height: $fn-lh-h1;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h1-mobile;\n    }\n  }\n\n  h2,\n  .h2-text {\n    font-size: $fn-fs-h2;\n    line-height: $fn-lh-h2;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h2-mobile;\n    }\n  }\n\n  h3,\n  .h3-text {\n    font-size: $fn-fs-h3;\n    line-height: $fn-lh-h3;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h3-mobile;\n    }\n  }\n\n  h4,\n  .h4-text {\n    font-size: $fn-fs-h4;\n    line-height: $fn-lh-h4;\n  }\n\n  h5,\n  .h5-text {\n    font-size: $fn-fs-h5;\n    line-height: $fn-lh-h5;\n  }\n\n  h6,\n  .h6-text {\n    font-size: $fn-fs-h6;\n    line-height: $fn-lh-h6;\n  }\n\n  $fn-title-subtext: 22px;\n  $fn-title-subtext-mobile: 18px;\n\n  p {\n    font-size: 18px;\n    line-height: 1.6;\n    color: $color-neutral-dark-500;\n    margin-top: 0;\n    margin-bottom: 10px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    @media #{$mobile} {\n      font-size: 16px;\n    }\n  }\n\n  ul,\n  ol {\n    padding: 0;\n    margin: 0;\n  }\n\n  sup {\n    font-size: 0.7em;\n    position: relative;\n    top: 5px;\n    display: inline-block;\n    vertical-align: top;\n  }\n}\n\n.bg-grey {\n  background-color: $clrGrey;\n}\n\n.fn-container {\n  max-width: $pageWidth;\n  width: calc(100% - 30px);\n  margin-inline: auto;\n\n  @media #{$tablet-up} {\n    margin-left: 0;\n  }\n\n  &--fluid {\n    max-width: $pageWidthFluid;\n  }\n\n  &--small {\n    max-width: $pageWidthSmall;\n    width: 100%;\n  }\n}\n\n.text {\n  &-center {\n    text-align: center;\n  }\n\n  &-right {\n    text-align: right;\n  }\n}\n\n.d {\n  &-none {\n    display: none;\n  }\n}\n\n.section-title {\n  text-align: center;\n\n  &:not(:last-child) {\n    margin-bottom: calc($secPad - 20px);\n  }\n\n  h2 {\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n  }\n\n  p {\n    max-width: 900px;\n    width: 100%;\n    margin-inline: auto;\n    font-size: $fn-title-subtext;\n\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n\n    @media #{$mobile} {\n      font-size: $fn-title-subtext-mobile;\n    }\n  }\n\n  .section-title__linkcontainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n\n    &:not(:last-child) {\n      margin-block-end: 20px;\n    }\n\n    & > * {\n      margin: 5px;\n    }\n\n    .fn-btn {\n      padding-block: 6px;\n      padding-inline: 13px;\n      font-size: 12px;\n      font-family: $muso-sans;\n    }\n  }\n}\n\n.section-padding {\n  padding-block: $secPad;\n\n  @media #{$mobile} {\n    padding-block: ($secPad - 20px);\n  }\n\n  &-small {\n    padding-block: calc($secPad / 2);\n  }\n\n  &-all {\n    padding: $secPad;\n\n    @media #{$mobile} {\n      padding: calc($secPad / 2);\n    }\n\n    &-small {\n      padding: calc($secPad / 2);\n    }\n  }\n}\n\n.headline {\n  --lineSize: 10px;\n  width: fit-content;\n  padding-block-end: calc(10px + var(--lineSize));\n  margin-inline: auto;\n  position: relative;\n\n  &--small-border {\n    --lineSize: 6px;\n  }\n\n  &:not(:last-child) {\n    margin-bottom: calc(var(--hGap) * 2.5);\n  }\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: var(--lineSize);\n    background: linear-gradient(\n      90deg,\n      $clarify-color 0%,\n      $clarify-color 25%,\n      $ideate-color 25%,\n      $ideate-color 50%,\n      $develop-color 50%,\n      $develop-color 75%,\n      $implement-color 75%,\n      $implement-color 100%\n    );\n  }\n}\n\n.custom-list {\n  li {\n    font-size: 18px;\n    line-height: 1.4;\n    color: $color-neutral-dark-500;\n    list-style: none;\n    position: relative;\n    padding-left: 15px;\n\n    &:not(:last-child) {\n      margin-bottom: 4px;\n    }\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: 10px;\n      left: 0;\n      width: 3px;\n      height: 3px;\n      background-color: var(--clrProfile);\n    }\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.fn-btn {\n  padding-block: 20px;\n  padding-inline: 28px;\n  background-color: $develop-color;\n  color: $clrWhite;\n  font-size: 18px;\n  line-height: 1.2;\n  display: inline-block;\n  font-family: $muso-700;\n  text-decoration: none;\n  word-break: break-all;\n  text-align: center;\n  transition: background-color 0.3s;\n\n  &:focus {\n    outline: 1px dashed $color-neutral-dark-500;\n    outline-offset: 4px;\n  }\n\n  &:hover {\n    background-color: $color-neutral-dark;\n    color: $clrWhite;\n  }\n\n  &--sm {\n    font-size: 14px;\n    padding-block: 10px;\n    padding-inline: 20px;\n  }\n\n  &--grey {\n    background-color: $color-neutral-light;\n    color: $color-neutral-dark;\n  }\n\n  &--ongoing {\n    background-color: $clrWarning;\n    color: $clrWhite;\n\n    i {\n      animation: spin 0.3s infinite;\n    }\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.w-4 {\n  width: calc(100% / 3);\n}\n\n.w-3 {\n  width: calc(100% / 4);\n\n  &--wd {\n    width: calc(100% / 3);\n  }\n}\n\n.w-6 {\n  width: calc(100% / 2);\n}\n\n.fn {\n  &-row {\n    --rGap: 15px;\n    --rGap-minus: calc(-1 * var(--rGap));\n\n    display: flex;\n    flex-wrap: wrap;\n    margin-inline: var(--rGap-minus);\n\n    &--col-gap-exist {\n      .fn-col {\n        margin-bottom: calc($secPad / 2);\n      }\n    }\n  }\n\n  &-col {\n    padding-inline: var(--rGap);\n  }\n\n  &-justify-center {\n    justify-content: center;\n  }\n\n  &-items-center {\n    align-items: center;\n  }\n}\n\n.m {\n  &x-auto {\n    margin-inline: auto;\n  }\n\n  &l-auto {\n    margin-inline-start: auto;\n  }\n\n  &l-0 {\n    margin-inline-start: 0;\n  }\n\n  &r-auto {\n    margin-inline-end: auto;\n  }\n\n  &r-0 {\n    margin-inline-end: 0;\n  }\n}\n","// Font\n@import './../../../../assets/styles/variables';\n\n::ng-deep .page-heading{\n  .col-lg-10{\n    /*float: left;\n    width: 75%;*/\n    &.header-full{\n      h2{\n        padding-right: 0px;\n      }\n\n      @media only screen and (min-width:769px){\n        width: 60%;\n      }\n\n      @media only screen and (max-width:768px){\n        width: 100%;\n        h2{\n          padding-right: 50px;\n        }\n      }\n    }\n  }\n\n  .header-back {\n    width: 25%;\n    float: left;\n    text-align: right;\n    padding-right: 0;\n    padding-top: 30px;\n\n    @media only screen and (max-width:768px){\n      padding-top: 50px;\n    }\n\n    &.full-screen-option{\n      width: 100%;\n      padding-top: 10px;\n      padding-right: 15px;\n\n      @media only screen and (min-width:769px){\n        width: 40%;\n        padding-top: 30px;\n      }\n\n      @media only screen and (max-height:736px) and (orientation:landscape){\n        padding-top: 0px;\n        float: right;\n        width:50%;\n        margin-top: -20px;\n      }\n    }\n  }\n}\n\n\n\n/*===== learner map css ============*/\n\n/* Style-for leaner-map */\n\n::ng-deep .course-index {\n  .ibox {\n    position: relative;\n\n    &:hover {\n\n      .product-box {\n        border: none;\n        box-shadow: 3px 3px 7px 0px #a8a8a8;\n      }\n\n      .icon-btn {\n        color: #48ac51;\n      }\n    }\n\n    input[type=checkbox] {\n      position: absolute;\n      width: 100%;\n      height: 100%;\n      opacity: 0;\n      cursor: pointer;\n      z-index: 1;\n\n      &:checked {\n\n        ~ div.product-box {\n          border: none;\n          box-shadow: 3px 3px 7px 0px #a8a8a8;\n\n          a.icon-btn {\n            color: #48ac51;\n          }\n        }\n\n        ~ div.popover {\n          display: block;\n          top: 130px;\n          left: -100px;\n          margin-top: 15px;\n          @media screen and (max-width: 679px) {\n            left: 0;\n            right: 0;\n            margin-left: auto;\n            margin-right: auto;\n            max-width: 350px;\n            min-width: auto;\n            width: 100%;\n          }\n\n          > .arrow {\n            left: 50%;\n            margin-left: -11px;\n            border-top-width: 0;\n            border-bottom-color: #999999;\n            border-bottom-color: rgba(0, 0, 0, 0.25);\n            top: -11px;\n\n            &:after {\n              content: \" \";\n              top: 1px;\n              margin-left: -10px;\n              border-top-width: 0;\n              border-bottom-color: #f7f7f7;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n::ng-deep .cta-wrapper{\n  @media only screen and (max-width: 1400px){\n    .list-group-item span {\n      max-width: 53%;\n      word-wrap: break-word;\n    }\n  }\n}\n\n::ng-deep .img-shadow{\n  box-shadow: inset 0 0 8px rgba(0,0,0,.6);\n  -moz-box-shadow: inset 0 0 8px rgba(0,0,0,.6);\n  -webkit-box-shadow: inset 0 0 8px rgba(0,0,0,.6);\n\n  background-size: 100% !important;\n  background-position: 0;\n\n  .build-form{\n    margin-top: 30px !important;\n  }\n}\n\n/* box-detail*/\n\n::ng-deep .dash-practitioner-wrapper, .wrapper-learner-map {\n\n  ::ng-deep .ibox.product-detail {\n\n    .ibox-content {\n\n      .image-imitation {\n        min-height: 642px !important;\n\n        @media only screen and (max-width: 1400px){\n          min-height: 350px !important;\n        }\n\n        .build-form{\n          input[type=\"email\"]{\n            width: 90%;\n          }\n\n          max-width: 300px;\n          margin: 0 auto;\n          float: none;\n\n          .fa{\n            cursor: pointer;\n          }\n\n          fieldset{\n            margin-bottom: 5px;\n          }\n        }\n\n      }\n    }\n  }\n}\n\n::ng-deep span.spacer {\n  display: block;\n  clear: both;\n  margin-bottom: 8px;\n}\n\n::ng-deep .media-container {\n  position: relative;\n  padding-top: 0%;\n  @media only screen and (max-width: 991px){\n    padding-top: 0%;\n    margin:15px 0px;\n  }\n  .image-imitation {\n    width: 100%;\n    position: absolute;\n    left: 0;\n    top: 0;\n    height: 100%;\n    min-height:inherit !important;\n    overflow: auto;\n\n    iframe {\n      width: 100%;\n      height: 100%;\n      position: absolute;\n      left: 0;\n      top: 0;\n    }\n  }\n}\n\n::ng-deep .work-well-slide{\n  h3{\n    font-size: 22px;\n  }\n\n  .title-sm{\n    margin-bottom: 50px !important;\n\n    @media(max-width: 767px){\n      margin-bottom: 25px !important;\n    }\n\n  }\n\n  .disabled{\n    height: 50px;\n    vertical-align: middle;\n    margin-top: 35px;\n    font-size: 28px;\n\n    @media(max-width: 767px){\n      margin: 0px;\n    }\n  }\n}\n\n::ng-deep .media-content {\n   position: static;\n\n  .confirmation-box{\n    padding: 5px;\n    border-top: 1px solid $color-neutral-mid;\n    border-bottom: 1px solid $color-neutral-mid;\n    //position: absolute;\n    //bottom: 10px;\n    width: 250px;\n    clear: both;\n    margin-top: 20px;\n  }\n\n\n  .checkbox-circle{\n    font-size: 13px;\n    font-style: italic;\n    float: right;\n    margin-right: -23px;\n    margin-top: 7px;\n\n    label{\n      line-height: 1.3em;\n    }\n\n    label::before{\n      margin-left: -19px;\n      outline: none;\n    }\n  }\n\n  .btn-success.btn-outline {\n    color: $develop-color;\n    border-color: $develop-color;\n    max-width: 60%;\n    margin: auto;\n\n    &:hover, &:active, &:focus {\n      background-color: $develop-color;\n      border-color: $develop-color;\n      color:$color-light-type;\n    }\n  }\n\n  .card-description p {\n    //font-size: 16px;\n    //line-height: 24px;\n    color: $color-neutral-dark;\n  }\n  .build-form {\n    max-width: 60%;\n    width: 100%;\n    margin:10px auto;\n\n    label {\n      display: block;\n      width:100%;\n\n      span {\n        display: inline-block;\n        margin:2px;\n        float: right;\n\n        &:hover {\n          cursor: pointer;\n        }\n      }\n    }\n\n    input {\n      height: 33px;\n      outline: none;\n      border:1px solid #888888;\n      width:100%;\n      border-radius:3px;\n      text-indent: 10px;\n      margin-bottom: 10px;\n\n      &:focus {\n        border:1px solid $develop-color\n      }\n    }\n  }\n}\n\n::ng-deep .media-container {\n\n  .btn-develop {\n    border:1px solid $develop-color;\n    background:$develop-color;\n\n    &:hover, &:active, &:focus {\n      background-color: #449d44;\n      border: 1px solid #449d44;\n      color:$color-light-type;\n    }\n  }\n}\n\n\n::ng-deep .map-btn {\n  /*color: $develop-color;*/\n  /*border-color: $develop-color;*/\n  max-width: 200px;\n  margin: 40px auto 0px;\n  width:100%;\n  display: block;\n  &.btn-develop:hover {\n    border:1px solid #449d44;\n    background:#449d44;\n  }\n\n  &:hover, &:active, &:focus {\n    background-color: $develop-color;\n    border-color: $develop-color;\n    color:$color-light-type;\n  }\n}\n\n::ng-deep .media-content {\n  padding-right: 40px;\n\n  .btn-develop {\n    background: $develop-color;\n    border-color: $develop-color;\n\n    &:active, &:focus, &:hover {\n      background:#449d44;\n      border: 1px solid #449d44;\n      color:$color-light-type;\n    }\n  }\n\n  h2{\n    a.grey-link{\n      position: absolute;\n      right: 10px;\n    }\n  }\n}\n\n::ng-deep .map-img {\n  margin-top: 45px !important;\n}\n\n::ng-deep .work-modal {\n  font-size: 14px;\n\n  .btn-example {\n    display: inline-block;\n    cursor: pointer;\n  }\n\n  .work-modal_popup {\n    display: none;\n\n    &.active {\n      display: block;\n      position:fixed;\n      top:0;\n      left:0;\n      width:100%;\n      height: 100%;\n      background:rgba(0,0,0,.5);\n      z-index: 9999;\n    }\n\n    .popup_content {\n      position:absolute;\n      top:50%;\n      max-width: 600px;\n      background:rgba(255,255,255,.9);\n      left:0;\n      right:0;\n      font-size: 18px;\n      padding:20px;\n      margin: auto;\n      -webkit-transform: translateY(-50%);\n      -ms-transform: translateY(-50%);\n      transform: translateY(-50%);\n\n      h3 {\n        font-size: 24px;\n      }\n\n      .clx-example {\n        position:absolute;\n        right:-30px;\n        top:-30px;\n        display: inline-block;\n        font-size: 24px;\n        color:$color-light-type;\n        cursor: pointer;\n      }\n    }\n  }\n}\n\n::ng-deep .card-description{\n  p{\n    font-size: 13px;\n\n    strong{\n      display: block;\n      margin-bottom: 5px;\n    }\n  }\n}\n\n::ng-deep .activeBox{\n  color:#48ac51 !important;\n}\n\n::ng-deep .user-profile-wrapper a {\n  color:#333;\n  text-decoration: underline;\n  &:hover , &:focus, &:active {\n    color:#333;\n    text-decoration: none;\n  }\n}\n\n::ng-deep .m-t-xs {\n  padding-bottom:50px;\n}\n\n::ng-deep .nav-header .thumbs img {\n  max-width: 60%;\n}\n\n\n\n/*--- dashboard-new circles style ---*/\n::ng-deep .dashboard-new{\n  min-width: 755px;\n  max-width: 755px;\n  min-height: 525px;\n  width: 95%;\n  margin: 25px auto 0 auto;\n  // background-color: rgba(255,255,255,0.85);\n  // -webkit-box-shadow: 0px 1px 8px -5px $body-content-color;\n  // -moz-box-shadow: 0px 1px 8px -5px $body-content-color;\n  // -ms-box-shadow: 0px 1px 8px -5px $body-content-color;\n  // -o-box-shadow: 0px 1px 8px -5px $body-content-color;\n  // box-shadow: 0px 1px 8px -5px $body-content-color;\n  // border: 1px solid $border-color;\n  padding-top: 35px;\n\n  @media only screen and (max-width:1023px){\n    body.dash-admin-3:not(.mini-navbar) &{\n      min-width: 510px;\n    }\n  }\n\n  @media only screen and (max-width:960px){\n    body.mini-navbar &{\n      min-width: 510px;\n    }\n  }\n\n  @media only screen and (max-width:767px){\n    min-width: 100% !important;\n  }\n\n\n\n  h1, p{\n    margin: 0;\n    // color: $text-color;\n    // font-family: $muso-sans;\n    // font-weight: bold;\n  }\n\n  .footer-images{\n    //background-color: $light-gray;\n    padding:25px 20px;\n    margin-top: 20%;\n    margin-bottom: 25px;\n    display: table;\n    width: 100%;\n    .col-xs-6{\n      padding: 0;\n      line-height: 29px;\n      img{\n        max-width: 100%;\n        vertical-align: bottom;\n      }\n    }\n    @media only screen and (max-width:767px){\n      margin-top: 20px;\n    }\n\n  }\n\n\n\n  h1{\n    //margin-top: 55px;\n\n    @media only screen and (min-width:769px) and (max-width:960px){\n      body.dash-admin-3:not(.mini-navbar) &{\n        margin-top: 25px;\n      }\n    }\n\n    @media only screen and (max-width:767px){\n      margin-top: 25px;\n    }\n\n    @media only screen and (max-width:600px){\n      font-size: 25px;\n      margin-top: 0px;\n    }\n  }\n\n  .dashboard-inner-block{\n    max-width: 670px;\n    width: 95%;\n    margin: 0 auto;\n    padding: 0;\n    position: relative;\n\n    ul{\n      padding: 0;\n      margin: -80px 0 0 0;\n      list-style: none;\n      display: table;\n      width: 100%;\n\n      @media only screen and (min-width:769px) and (max-width:960px){\n        body.dash-admin-3:not(.mini-navbar) &{\n          margin-top: 25px;\n          text-align: center;\n        }\n      }\n\n      @media only screen and (max-width:767px){\n        margin-top: 25px;\n        text-align: center;\n      }\n\n      -webkit-transition:all 300ms ease;\n      -moz-transition:all 300ms ease;\n      -ms-transition:all 300ms ease;\n      -o-transition:all 300ms ease;\n      transition:all 300ms ease;\n\n      *{\n        -webkit-transition:all 300ms ease;\n        -moz-transition:all 300ms ease;\n        -ms-transition:all 300ms ease;\n        -o-transition:all 300ms ease;\n        transition:all 300ms ease;\n      }\n\n      li{\n        max-width: 134px;\n        min-height: 330px;\n        line-height: 330px;\n        float: none;\n        display: table-cell;\n        position: relative;\n\n        @media only screen and (min-width:769px) and (max-width:960px){\n          body.dash-admin-3:not(.mini-navbar) &{\n            display: inline-block;\n            width: 50%;\n            min-height: 200px;\n            line-height: 200px;\n            margin-bottom: 25px;\n          }\n        }\n\n        @media only screen and (max-width:767px){\n          display: inline-block;\n          width: 100%;\n          max-width: 100%;\n          // min-height: 200px;\n          // line-height: 200px;\n          min-height: inherit;\n          line-height: inherit;\n          margin-bottom: 25px;\n\n          &:first-child, &:last-child{\n            min-height: initial !important;\n            line-height: initial !important;\n          }\n          &:last-child{\n            margin-bottom: 35px;\n          }\n        }\n\n        @media only screen and (max-width:413px){\n          body.mini-navbar &{\n            width: 100%;\n          }\n        }\n\n        *{\n          line-height: normal;\n        }\n\n        .circle{\n          display: inline-block;\n          vertical-align: bottom;\n          background-color: #fab254;\n          border-radius: 50%;\n          width: 108px;\n          height: 108px;\n          line-height: 108px;\n          text-align: center;\n          position: relative;\n          -webkit-box-shadow: 0px 5px 25px -3px $body-content-color;\n          -moz-box-shadow: 0px 5px 25px -3px $body-content-color;\n          -ms-box-shadow: 0px 5px 25px -3px $body-content-color;\n          -o-box-shadow: 0px 5px 25px -3px $body-content-color;\n          box-shadow: 0px 5px 25px -3px $body-content-color;\n          cursor: pointer;\n\n          &:hover, &:focus{\n            -webkit-box-shadow:0px 0px 20px -3px $body-content-color;\n            -moz-box-shadow:0px 0px 20px -3px $body-content-color;\n            -ms-box-shadow:0px 0px 20px -3px $body-content-color;\n            -o-box-shadow:0px 0px 20px -3px $body-content-color;\n            box-shadow:0px 0px 20px -3px $body-content-color;\n\n            .fa{\n              color: #293846;\n            }\n          }\n\n          &:after{\n            content: \"\";\n            border:1px solid #db6e57;\n            width: 50px;\n            display: inline-block;\n            position: absolute;\n            right: -48px;\n            top: 40%;\n            transform:translate(0%, -50%) rotate(-25deg);\n\n            @media only screen and (max-width:767px){\n              //content: none;\n              transform: translate(0%, -50%) rotate(90deg) !important;\n              right: 29px !important;\n              bottom: -26px;\n              top: inherit !important;\n            }\n          }\n\n          &.circle2{\n            margin-bottom: 20px;\n\n            &:after{\n              right: -48px;\n              top: 40%;\n              transform:translate(0%, -50%) rotate(-25deg);\n            }\n          }\n\n          &.circle3{\n            margin-bottom: 20px * 3;\n            &:after{\n              right: -42px;\n              top: 17%;\n              transform:translate(0%, -50%) rotate(-35deg);\n            }\n          }\n\n          &.circle4{\n            margin-bottom: 20px * 7;\n            &:after{\n              right: -42px;\n              top: 17%;\n              transform:translate(0%, -50%) rotate(-35deg);\n            }\n          }\n\n          &.circle5{\n            vertical-align: top;\n            &:after{\n              content: none;\n            }\n          }\n\n          @media only screen and (min-width:769px) and (max-width:960px){\n            body.dash-admin-3:not(.mini-navbar) &{\n              vertical-align: top;\n\n              &:after{\n                right: -50px;\n                top: 50%;\n                transform:translate(0%, -50%) rotate(0deg);\n              }\n\n              &.circle2, &.circle3, &.circle4, &.circle5{\n                margin: 0;\n              }\n\n              &.circle4{\n                &:after{\n                  content: none;\n                }\n              }\n\n              &.circle5{\n                vertical-align: top;\n              }\n            }\n          }\n\n          @media only screen and (min-width:769px) and (max-width:863px){\n            body.dash-admin-3:not(.mini-navbar) &{\n              &.circle3{\n                &:after{\n                  content: none;\n                }\n              }\n              &.circle4{\n                &:after{\n                  content: \"\";\n                }\n              }\n            }\n          }\n\n          @media only screen and (max-width:767px){\n            vertical-align: top;\n\n            &.circle2, &.circle3, &.circle4, &.circle5{\n              margin: 0;\n            }\n\n            &.circle5{\n              vertical-align: top;\n            }\n          }\n\n          a{\n            display: inline-block;\n            vertical-align: middle;\n            h4{\n              line-height: 1;\n              font-size: 12px;\n              color: #000;\n              font-family: $muso-sans;\n              span{\n                display: block;\n                // text-transform: uppercase;\n              }\n            }\n          }\n\n          .fa{\n            font-size: 18px !important;\n            color: $color-light-type;\n          }\n        }\n\n        .sub-circle{\n          width: 74px;\n          height: 74px;\n          line-height: 74px;\n          background-color: #db6e57;\n          border-radius: 50%;\n          text-align: center;\n          position: absolute;\n          bottom: -71px;\n          left: -20px;\n          right: 0;\n          margin: 0 auto;\n          -webkit-box-shadow: 0px 3px 10px -3px $body-content-color;\n          -moz-box-shadow: 0px 3px 10px -3px $body-content-color;\n          -ms-box-shadow: 0px 3px 10px -3px $body-content-color;\n          -o-box-shadow: 0px 3px 10px -3px $body-content-color;\n          box-shadow: 0px 3px 10px -3px $body-content-color;\n\n          @media only screen and (min-width:769px) and (max-width:960px){\n            body.dash-admin-3:not(.mini-navbar) &{\n              bottom:0px;\n            }\n          }\n\n          @media only screen and (max-width:767px){\n            bottom:-55px;\n            left: 0px;\n            right: 200px;\n          }\n\n          @media only screen and (max-width:413px){\n            body.mini-navbar &{\n              left: 0px !important;\n            }\n          }\n\n          &:before{\n            content: \"\";\n            height: 18px;\n            border:1px solid #db6e57;\n            width: 1px;\n            margin: 0 auto;\n            display: inline-block;\n            position: absolute;\n            left: 0;\n            right: 0;\n            top:-17px;\n            @media only screen and (max-width:767px){\n              height: 45px !important;\n              top:-20px !important;\n              right: -75px !important;\n              transform: rotate(50deg) !important;\n              z-index: -1;\n            }\n          }\n\n          a{\n            display: inline-block;\n            vertical-align: middle;\n            h6{\n              line-height: 1;\n              font-size: 11px;\n              margin: 0 0 5px 0;\n              color: $color-light-type;\n              font-family: $muso-sans;\n              span{\n                display: block;\n                // text-transform: uppercase;\n              }\n            }\n          }\n\n          .fa{\n            font-size: 18px !important;\n            color: $color-light-type;\n          }\n\n          &.sub-circle2{\n            margin-bottom: 40px;\n            left: 20px;\n            @media only screen and (min-width:769px) and (max-width:960px){\n                body.dash-admin-3:not(.mini-navbar) &{\n                  left: 0px;\n                  margin-bottom: 0;\n                }\n            }\n\n            @media only screen and (max-width:767px){\n              left: 0px;\n              margin-bottom: 0;\n            }\n\n            &:before{\n              left: -20px;\n              transform:rotate(-20deg);\n              -webkit-transform:rotate(-20deg);\n              -moz-transform:rotate(-20deg);\n              @media only screen and (min-width:769px) and (max-width:960px){\n                body.dash-admin-3:not(.mini-navbar) &{\n                  left: 0px;\n                  transform:none;\n                }\n              }\n\n              @media only screen and (max-width:767px){\n                left: 0px;\n                transform:none;\n              }\n            }\n          }\n\n          &.sub-circle3{\n            margin-bottom: 120px;\n            left: 40px;\n            @media only screen and (min-width:769px) and (max-width:960px){\n                body.dash-admin-3:not(.mini-navbar) &{\n                  left: 0px;\n                  margin-bottom: 0;\n                }\n            }\n\n            @media only screen and (max-width:767px){\n              left: 0px;\n              margin-bottom: 0;\n            }\n\n            &:before{\n              left: -30px;\n              height: 23px;\n              top: -18px;\n              transform:rotate(-25deg);\n              @media only screen and (min-width:769px) and (max-width:960px){\n                body.dash-admin-3:not(.mini-navbar) &{\n                  left: 0px;\n                  height: 18px;\n                  top:-17px;\n                  transform:none;\n                }\n              }\n\n              @media only screen and (max-width:767px){\n                left: 0px;\n                height: 18px;\n                top:-17px;\n                transform:none;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n::ng-deep .dash-admin-2{\n  .dashboard-new h1{\n    font-family: $muso-700;\n    color: $color-light-type;\n  }\n  .dashboard-new p{\n    color: $color-light-type;\n    font-family: $muso-300;\n    font-weight: normal;\n  }\n}\n\n/* iCheck plugin Square skin, green\n----------------------------------- */\n.icheckbox_square-green,\n.iradio_square-green {\n    display: inline-block;\n    *display: inline;\n    vertical-align: middle;\n    margin: 0;\n    padding: 0;\n    width: 22px;\n    height: 22px;\n    //background: url(green.png) no-repeat;\n    border: none;\n    cursor: pointer;\n}\n\n.icheckbox_square-green {\n    background-position: 0 0;\n}\n.icheckbox_square-green.hover {\n    background-position: -24px 0;\n}\n.icheckbox_square-green.checked {\n    background-position: -48px 0;\n}\n.icheckbox_square-green.disabled {\n    background-position: -72px 0;\n    cursor: default;\n}\n.icheckbox_square-green.checked.disabled {\n    background-position: -96px 0;\n}\n\n.iradio_square-green {\n    background-position: -120px 0;\n}\n.iradio_square-green.hover {\n    background-position: -144px 0;\n}\n.iradio_square-green.checked {\n    background-position: -168px 0;\n}\n.iradio_square-green.disabled {\n    background-position: -192px 0;\n    cursor: default;\n}\n.iradio_square-green.checked.disabled {\n    background-position: -216px 0;\n}\n\n/* HiDPI support */\n@media (-o-min-device-pixel-ratio: 5/4), (-webkit-min-device-pixel-ratio: 1.25), (min-resolution: 120dpi) {\n    .icheckbox_square-green,\n    .iradio_square-green {\n        //background-image: url(green@2x.png);\n        -webkit-background-size: 240px 24px;\n        background-size: 240px 24px;\n    }\n}\n\n\n::ng-deep .learner-rating{\n  max-width: 230px;\n  margin: 0 auto;\n  margin-top: 25px;\n\n  .inner-learner-rating{\n    & > div{\n      display: inline-block;\n      float: left;\n      margin: 0 12px;\n    }\n  }\n\n  .text-label{\n    margin-left: 10px;\n    margin-right: 10px;\n    font-size: 12px;\n  }\n}\n\n::ng-deep .rating-wrap{\n  .build-form{\n    max-width: 350px !important;\n\n    h3{\n      font-size: 16px;\n      line-height: 1.2em;\n    }\n  }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
